import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import zIndex from '@material-ui/core/styles/zIndex';

const styles = theme => ({
  root: {
    padding: '4px 24px',
    minHeight: 48,
    backgroundColor: theme.palette.common.white,
    position: 'relative',
    zIndex: 1,
    flexWrap: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 8,
      paddingRight: 8,
    },
  },
  rootFixed: {
    position: 'sticky',
    zIndex: 40,
    backgroundColor: theme.palette.grey[100],
    marginBottom: 16,
    marginTop: -16,
    paddingLeft: 0,
    borderBottom: `1px solid ${theme.palette.active[50]}`,
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      left: -8,
      width: 8,
      bottom: 0,
      backgroundColor: theme.palette.grey[100],
    },
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      right: -8,
      width: 8,
      bottom: 0,
      backgroundColor: theme.palette.grey[100],
    },
  },
  rootNotFixed: {
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    position: 'static',
    boxShadow: '0 2px 10px 0 rgba(72,126,161,0.14)',
    '& + div': {
      position: 'relative',
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      
    },
    '& + div:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      zIndex: 1,
      top: -6,
      left: 0,
      right: 0,
      height: 5,
      backgroundColor: theme.palette.common.white,
    },
  },
});

const SectionHeader = ({
  className, classes, children, fixed, top,
}) => (
  <Grid
    className={classNames(className, classes.root, {
      [classes.rootFixed]: fixed,
      [classes.rootNotFixed]: !fixed,
    })}
    component="header"
    container
    justify="space-between"
    spacing={0}
    alignItems="center"
    {...fixed ? {
      ...top ? {
        style: { top: `${top}px` },
      } : {
        style: { top: '64px' },
      }
    } : {}}
  >
    {children}
  </Grid>
);

SectionHeader.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  top: PropTypes.number,
  fixed: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

SectionHeader.defaultProps = {
  className: '',
  fixed: false,
  top: 64,
};

export default withStyles(styles)(SectionHeader);



// WEBPACK FOOTER //
// ./src/components/common/Section/SectionHeader.js